<div class="advocate-unavailable-group">
  <div class="advocate-unavailable-text">
    {{ careAdvocateNotAssignedMessage.title }}
  </div>
  <div class="advocate-unavailable-subtext">
    {{ careAdvocateNotAssignedMessage.msg }}
  </div>
</div>
